<template>
  <div
    v-if="isBtoC"
    class="page-block">
    <header-bar v-if="isLoggedIn">キャンペーン規約</header-bar>
    <div class="page-block__heading page-block__heading--withbar">
      <h3 class="page-block__title">「narasuで鳴らす♪春の楽曲制作キャンペーン！」</h3>
    </div>
    <div class="page-block__inner">
      <div
        class="terms-area">
        <div class="terms-text__box">
        </div>
        <h4>■ 応募規約</h4>
        <div class="terms-text__box">
          <p>
            株式会社ローディアム（以下、「当社」といいます）が主催する「narasuで鳴らす♪春の楽曲制作キャンペーン！」 （以下、「本キャンペーン」といいます）にご応募いただく前に、
            本規約をよくお読みいただき、ご同意の上、ご応募ください。本キャンペーンにご応募された場合、本規約にご同意いただいたものとみなします。
          </p>
        </div>
        <h4>■ 応募期間</h4>
        <div class="terms-text__box">
          <p>
            2022年4月1日(金) 00:00 〜 5月31日(火) 23:59まで
          </p>
        </div>
        <h4>■ 副賞</h4>
        <div class="terms-text__box">
          <p>
            期間中にご応募された方の中から、優秀楽曲1作品を対象にnarasuサービス利用料(660円/税込)を最大6ヶ月無料（3,960円/税込）といたします。
          </p>
        </div>
        <h4>■ 応募方法</h4>
        <div class="terms-text__box">
          <ol>
            <li>
              ①応募楽曲をnarasuで配信申請。
            </li>
            <li>
              ②お問い合わせフォームから「キャンペーン応募」を選択し、必須事項を記載してエントリー。
            </li>
            <li>
              ③楽曲のクオリティにおいて、審査委員会にて厳正な審査の上、受賞者にはメールで連絡。
            </li>
          </ol>
        </div>
        <h4>■ 応募条件</h4>
        <div class="terms-text__box">
          <ol>
            <li>
              ・本規約に同意すること
            </li>
            <li>
              ・未成年の応募者については、ご応募ついて、親権者の同意が得られていること
            </li>
            <li>
              ・受賞候補に選ばれた場合、当社が指定する様式より本規約の同意をいただけること
            </li>
            <li>
              ・受賞楽曲は、当社SNSを含む広告媒体等でPRに利用させていただくことがございます。
            </li>
            <li>
              ・当社指定様式に同意いただけない場合は、受賞候補の権利を無効とすることがあります。
            </li>
            <li>
              ・期間中、同一アカウントからの応募は1曲のみとし、同一アカウントの複数曲の応募は無効とさせていただきます。
            </li>
          </ol>
        </div>
        <h4>■ 結果発表/通知</h4>
        <div class="terms-text__box">
          <ol>
            <li>
              ・応募締切後、厳正な審査を行い受賞候補者を決定いたします。
            </li>
            <li>
              ・受賞の候補者様には、2022年6月20日(月)週にご登録のメールアドレス宛にご連絡いたします（受賞確定のご連絡ではありませんのでご注意ください）。
            </li>
            <li>
              ・受賞の権利はご本人のものとし、第三者に権利譲渡はできません。
            </li>
            <li>
              ・審査方法や内容・結果については個別にお答えいたしかねますので、あらかじめご了承ください。
            </li>
          </ol>
          <br>
          <p>
            ＜受賞候補の連絡に関して＞
            <br>・必要事項の入力漏れや虚偽の記載があれば、受賞の権利を無効とさせていただきます。また連絡先が不明で連絡ができない場合も受賞の権利を無効とさせていただきます。
          </p>
        </div>
        <h4>■ 副賞の授与について</h4>
        <div class="terms-text__box">
          <ol>
            <li>
              ・副賞のサービス利用料無料特典につきましては、2022年7月のサービス利用料からの適用を予定しております。
            </li>
            <li>
              ・副賞の授与後、本規約違反が発覚した場合、受賞者は副賞相当額を返還するものとします。
            </li>
          </ol>
        </div>
        <h4>■ 注意事項</h4>
        <div class="terms-text__box">
          <ol>
            <li>
              ・著作権侵害に該当する等の不正行為と当社が判断した場合、事前予告なく応募及び受賞を無効とさせていただく場合がございます。
            </li>
            <li>
              ・本キャンペーンは、やむを得ない事情により中止または内容が変更となる場合がございますので、あらかじめご了承ください。
            </li>
            <li>
              ・必要と判断した場合には、本規約を変更できるほか、本キャンペーンの適正を確保するために必要なあらゆる対応をとることができるものとします。
            </li>
          </ol>
        </div>
        <h4>■ 禁止事項</h4>
        <div class="terms-text__box">
          <p>
            当社は、お客様が本キャンペーンの利用に際して、以下に定める行為（それらを誘発する行為や準備行為を含む）を行うことを禁止します。
            当社がかかる禁止行為を発見した場合、当社は、当該禁止行為をしたお客様への通知および同意なく、当該禁止行為の結果につき、
            当該禁止行為の結果もしくは効果を除去する措置をすることができるものとします。当社は、当該措置を講じたことによってお客様に生じた損害につき、一切責任を負いません。
          </p>
          <ol>
            <li>
              （1）他のお客様もしくは第三者もしくは当社の財産権やプライバシーを侵害する行為、または侵害するおそれのある行為
            </li>
            <li>
              （2）他のお客様および第三者もしくは当社を誹謗または中傷したり名誉を毀損する行為、またはそれらのおそれのある行為
            </li>
            <li>
              （3）他のお客様もしくは第三者もしくは当社の知的財産権（著作権・意匠権・特許権・実用新案権・商標権・肖像権・その他）を侵害する行為、または侵害するおそれのある行為
            </li>
            <li>
              （4）有害なコンピュータープログラム等を送信、または書き込む行為、または不正な手段でアクセスする行為
            </li>
            <li>
              （5）公序良俗に反する行為、犯罪行為、青少年の心身に悪影響を及ぼす行為、またはそのおそれのある行為
            </li>
            <li>
              （6）当社に承認なく本キャンペーンを通じて、または本キャンペーンに関連して営利を目的とする行為、またはその準備を目的とする行為
            </li>
            <li>
              （7）選挙活動、またはこれに類する行為、その他政治もしくは宗教に関する行為
            </li>
            <li>
              （8）その他本キャンペーンの運営を妨げるような行為
            </li>
            <li>
              （9）第三者になりすまして本キャンペーンを利用する行為
            </li>
            <li>
              （10）方法の如何を問わず、他の会員のIDやパスワードを入手、開示、提供する行為
            </li>
            <li>
              （11）日本国またはご利用の際にお客様が所在する国・地域の法令に違反する行為
            </li>
            <li>
              （12）当サイトまたはそのウェブサーバのセキュリティホールやバグの利用、人為的な高負荷アクセスを発生させる行為、当サイトまたはその上にある情報の改ざん、消去する行為
            </li>
            <li>
              （13）他のお客様その他の第三者に迷惑となる行為や不快感を抱かせる行為
            </li>
            <li>
              （14）虚偽または誤認を与える情報を入力、送信する行為
            </li>
            <li>
              （15）当社、当社の役職員もしくは他のお客様に対し、暴力、威迫、威力もしくは偽計を用い何らかの要求をなし、または不当な要求をすること
            </li>
            <li>
              （16）その他本規約または関連する規約に違反する行為
            </li>
          </ol>
        </div>
        <h4>■ 選考対象外</h4>
        <div class="terms-text__box">
          <p>
            応募の内容が以下に該当する場合は、本キャンペーンの選考対象外といたします。また、受賞決定後に応募の内容が以下に該当することが判明した場合には受賞を取り消すことがございます。
            また、第三者の著作権、商標権等の知的財産権を侵害または、法令に違反するおそれのある内容の書き込みや画像等の使用は一切禁止します。
          </p>
          <ol>
            <li>
              ・本規約の定めに抵触するもの
            </li>
            <li>
              ・本キャンペーンの適正な運営を妨げるもの又はその恐れのあるもの
            </li>
            <li>
              ・公序良俗に反し、又は反する恐れのあるもの
            </li>
            <li>
              ・法令等に違反し、又は犯罪行為に結びつくもの又はその恐れのあるもの
            </li>
            <li>
              ・第三者の著作権、商標権等の知的財産権を侵害するもの又はその恐れのあるもの
            </li>
            <li>
              ・上記のほか本キャンペーンの趣旨・目的に合わないと当社が判断したもの
            </li>
          </ol>
        </div>
        <h4>■ 個人情報の取り扱い</h4>
        <div class="terms-text__box">
          <p>
            本キャンペーンで取得したお客様の個人情報は、次の目的の範囲内で利用し、個人情報の保護に関する法律等を遵守し、当社の「プライバシーポリシー」（<a
              class="c-text-link"
              href="https://narasu.jp/client/static/privacy"
              target="_blank">https://narasu.jp/client/static/privacy</a>）に従って厳重に取り扱います。
          </p>
          <ol>
            <li>
              （1）お客様からのお問合せ等に対する回答のご連絡
            </li>
            <li>
              （2）副賞授与に伴うご連絡
            </li>
            <li>
              （3）個人を特定しない形でサービス向上のための統計データとしての利用
            </li>
            <li>
              ・利用目的の達成に必要な範囲内において第三者に個人情報の取扱委託を行う場合または法令等で開示が求められた場合を除き、
              事前にお客様の同意を得ずに第三者に提供することはありません。
            </li>
          </ol>
        </div>
        <h4>■ その他</h4>
        <div class="terms-text__box">
          <ol>
            <li>
              ・本キャンペーンに応募していただくにあたり、お客様は運営方法に従い、当該運営方法について一切異議を申し立てないものとします。
            </li>
            <li>
              ・事情の如何を問わず、本キャンペーンサイトの利用または利用不能によりお客様に損害が生じたとしても、当社もしくは運営関係者に故意または重大な過失がない限り、
              当社および運営関係者は当該損害につき責任を負わないものとします。
            </li>
          </ol>
        </div>
        <div class="c-btn-wrap">
          <router-link
            :to="{ name: 'index' }"
            class="c-btn c-btn--back">
            トップへ戻る
            <span class="c-btn__icon-arrow c-btn__icon-arrow--left"></span>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import HeaderBar from '../HeaderBar'

export default {
  name: 'NarasuSpringCampaign2022',
  components: { HeaderBar },
  computed: {
    ...mapGetters('auth', ['isLoggedIn']),
  },
}
</script>

<style lang="scss" scoped>
  ol.numbered{
    margin-left: 1.2em;
    & > li{
    list-style: decimal;
      }
  }
</style>
